import { useParams } from 'react-router';
import { useGetSelectedTourStatus } from '../../api/LogbookApi';

export default function NavigationHelper() {
    const id = useParams().id;
    return useGetSelectedTourStatus(id);
}
